import { StorageService } from 'app/core/services/storage.service';
import { Component, OnInit, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { SmartModalService } from 'app/core/services/smart-modal.service';

@Component({
    selector: 'itpx-vimeo-modal',
    templateUrl: './vimeo-modal.component.html',
    styleUrls: ['./vimeo-modal.component.css']
})
export class VimeoModalComponent implements OnInit {

    @Input()
    private data: any;
    private url: any;

    constructor(
        private sanitizer: DomSanitizer,
        private modalService: SmartModalService,
        private storageService: StorageService) { }

    ngOnInit() {

        let autoplay = this.data.userOpened ? 1 : 0;
        let unsafeUrl = `https://player.vimeo.com/video/${this.data.id}?autoplay=${autoplay}`;
        this.url = this.sanitizer.bypassSecurityTrustResourceUrl(unsafeUrl);
    }

    private onOk() {
        this.modalService.sendResult(true);
    }

    private onDontShowAgain() {
        // this.storageService.set(this.data.category, true);
        this.modalService.sendResult(true);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/vimeo-modal/vimeo-modal.component.ts